import { render, staticRenderFns } from "./FormCRS.vue?vue&type=template&id=b812e3d6&scoped=true"
import script from "./FormCRS.vue?vue&type=script&lang=js"
export * from "./FormCRS.vue?vue&type=script&lang=js"
import style0 from "./FormCRS.vue?vue&type=style&index=0&id=b812e3d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b812e3d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b812e3d6')) {
      api.createRecord('b812e3d6', component.options)
    } else {
      api.reload('b812e3d6', component.options)
    }
    module.hot.accept("./FormCRS.vue?vue&type=template&id=b812e3d6&scoped=true", function () {
      api.rerender('b812e3d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/clientForms/FormCRS.vue"
export default component.exports